module.exports = __webpack_public_path__ + "media/application/images/demo/content_10-cacd0a991972530bb845d7ac10e873ca.jpg";